import RGBA from '../../valueObjects/RGBA.js';

class RangeToColorConverterBase{
    /**
     * Returns RGBA color for given numeric range defined as from to compared to min and max value of entire set
     * @param {Number} from 
     * @param {Number} to 
     * @param {Number} min 
     * @param {Number} max 
     * @returns {RGBA} RGBA color instance calculated for given range
     */
    getColor(from, to, min, max){
        return new RGBA();
    }
}

export default RangeToColorConverterBase;